import useQueryParams from '../../hooks/useQueryParams';

// Website host for the sign-up link. Override with REACT_APP_WEBSITE_HOST for
// local dev (e.g. point at a website running on localhost).
const websiteHost = process.env.REACT_APP_WEBSITE_HOST || 'https://www.beautypass.app';

export const Footer = () => {
  const { getQueryParam } = useQueryParams();
  const instaHandle = getQueryParam('referralInstaHandle');

  return (
    <div className='login-footer-account-container'>
      <span className='dont-have-account'>Don't have an account?</span>
      <a
        href={`${websiteHost}/sign-up${
          instaHandle ? `?referralInstaHandle=${instaHandle}` : ''
        }`}
        className='login-footer-create-account'
        target='_blank'
      >
        Create a business account
      </a>
    </div>
  );
};
